import { Toaster } from "@/components/ui/sonner";
import { RouterProvider } from "react-router-dom";
import { SiteSettingsProvider } from "@/common/providers/site-settings";
import router from "./router";

function App() {
	return (
		<div>
			<Toaster />
			<SiteSettingsProvider>
				<RouterProvider router={router} />
			</SiteSettingsProvider>
		</div>
	);
}

export default App;
